module.exports = __webpack_public_path__ + "static/media/career_main.3c39671c.jpg";